<div class="card">
  <div class="card-header mm-card-header">
    MSO / Enterprise Groups
  </div>
  <div class="card-body col-md-12">
    <lib-alert-banner
        *ngIf="shouldShowPasswordResetBanner()"
        [alertType]="passwordResetBannerAlertType"
        [hidden]="false"
        [maxWidth]="'100%'"
        [message]="passwordResetBannerMessage"
        class="mb-3">
    </lib-alert-banner>
    <div class="row mb-3">
        <form [formGroup]="formGroupOverview">
            <input type="search" class="display-search-icon m-lg-1" data-identifier="searchGroupTerm" placeholder="&#xF002; Search by Group, FGI or Instance prefix"
                   (keyup.enter)="searchGroup()"
                   formControlName="searchGroupTerm" maxlength="255" length="255" size="50">
            <button type="button" class="btn btn-sm btn-primary" data-identifier="searchGroupBtn" (click)="searchGroup()">Search</button>
            <button type="button" class="btn btn-sm btn-primary float-end" [routerLink]="['/group-management/create']"  data-identifier="createGroupBtn">Create Group</button>
        </form>
    </div>

    <mmoga-groups-table
        #groups
        [isPasswordResetDisabled]="isPasswordResetActionDisabled()"
        (passwordResetRequested)="openPasswordResetModal($event)">
    </mmoga-groups-table>
  </div>
</div>
